/**
 * Minimum fraction of a pipe's length either half of a split may have.
 *
 * ⚠️ PROPORTIONAL, not an absolute pixel threshold. An absolute-px guard makes any pipe
 * shorter than ~2× the threshold unsplittable — a genuinely short run, or *any* run at
 * low zoom, which is exactly the large models most likely viewed fit-to-screen. That
 * would defeat the whole drop-a-device-on-a-pipe feature with a misdirecting "too close"
 * message.
 */
export const SPLIT_T_EPSILON = 0.001

/**
 * Keep a split's length apportioning off the endpoints.
 *
 * This guards the LENGTH, not the geometry: the inserted vertex still sits exactly where
 * the user clicked (on the rendered polyline). What it prevents is a half with a
 * `length` of ~0 — a pipe the solver will happily consume and that no one can select or
 * edit meaningfully.
 *
 * A non-finite `t` falls back to the midpoint rather than propagating NaN into a
 * `length` value, where it would surface much later as an unexplained solver failure.
 */
export function clampSplitT(t: number): { t: number; clamped: boolean } {
  if (!Number.isFinite(t)) return { t: 0.5, clamped: true }
  if (t < SPLIT_T_EPSILON) return { t: SPLIT_T_EPSILON, clamped: true }
  if (t > 1 - SPLIT_T_EPSILON) return { t: 1 - SPLIT_T_EPSILON, clamped: true }
  return { t, clamped: false }
}
